'use client'
import React, { useState } from 'react'
import HeroSection from '@/components/industry-co-led/HeroSection';
import AboutProgram from '@/components/industry-co-led/AboutProgram';
import OurOffering from "@/components/industry-co-led/OurOffering";
import { bhaData } from '@/data/industry-co-led/Emversity/BhaData';
import { courseDetails } from '@/data/industry-co-led/redversity/courseDetails';
import WhySection from '@/components/industry-co-led/WhySection';
import MSUAdvantages from '@/components/industry-co-led/MSUAdvantages';
import CTASection from '@/components/industry-co-led/ui/CTASection';
import CurriculumStructure from "@/components/industry-co-led/CurriculumStructure";
import StudentStoriesSection from "@/components/industry-co-led/medhavianSpeak";
import FAQSection from "@/components/industry-co-led/FAQSection";
import InfrastructureSection from "@/components/industry-co-led/InfrastructureSection";
import AdditionalSkills from "@/components/industry-co-led/addintionSkill"
import OnTheJobTraining from '@/components/industry-co-led/OnTheJobTraining';
import UserFormModal from "@/components/industry-co-led/user-form-otp/UserFormModal";
import { useFormModal } from "@/context/FormContext";
import VideoModal from '@/components/videoModel';
import EligibilitySection from '@/components/industry-co-led/EligibilitySection';
import CareerProspects from '@/components/industry-co-led/CareerProspects';
import CourseStickyBar from '@/components/industry-co-led/CourseSticky';

const Bha = () => {
    const {
        isOpen,
        shouldDownload,
        closeForm,
        handleSuccess,
        openDownloadForm,
        openApplyForm,
        modal,
        closeVideo,
    } = useFormModal();

    const brochureUrl =
        "https://cdn.msu.edu.in/pdf/MSU_Fee_Structure_2026_27.pdf";

    const brochureName =
        "MSU-FEE-STRUCTURE-2026-27.pdf";

    return (
        <>

            <section className="w-full ">
                <HeroSection data={bhaData}
                    onDownload={() =>
                        openDownloadForm(
                            brochureUrl,
                            brochureName
                        )
                    }
                    onApply={() =>
                        openApplyForm()
                    }
                />
                <AboutProgram data={bhaData} />
                <OurOffering data={bhaData} />
                <WhySection data={bhaData} />
                <MSUAdvantages data={bhaData} />
                <CTASection data={bhaData}
                    onApplyNow={openApplyForm}
                />
                <OnTheJobTraining
                    data={bhaData.onJobtrainningData}
                />
                <AdditionalSkills courseSections={bhaData.addtionSkill.courseSections}
                    onApplyNow={openApplyForm}
                />
                <InfrastructureSection data={bhaData.DoExperienceLearndata} />
                <StudentStoriesSection studentStoriesData={bhaData.studentStoriesData} />
                <EligibilitySection data={bhaData} onApplyNow={openApplyForm} />
                <CareerProspects data={bhaData.careerProspects} />

                <CurriculumStructure curriculumData={bhaData.curriculumStructure} />
                <FAQSection course={bhaData.faq} />
            </section>

            <UserFormModal
                isOpen={isOpen}
                onClose={closeForm}
                onSuccess={handleSuccess}
                shouldDownload={shouldDownload}
                courseDetails={courseDetails.redversity.UG}
                specialization={"Hospital Administration"}
                course={"Bachelors (4 Years)"}
                schoolName={"Health Science & Technology"}
                stream={""}
                apiUrl={'https://lp.msu.edu.in/lead/api/industry-co-lead/emversity'}

            />

            <VideoModal
                open={modal.open}
                url={modal.url}
                onClose={closeVideo}
            />
            <CourseStickyBar coursePrice={bhaData.coursePrice} onApply={() => openApplyForm()} />
        </>
    )
}

export default Bha